import React from 'react'

function Error404() {
    return (
        <div>
            <h1>Page not found</h1>
        </div>
    )
}

export default Error404
